<template>
  <c-container v-if="env" form wide>
    <v-row>
      <v-col cols="12" sm="6">
        <c-account-panel :user="user"/>
      </v-col>
      <v-col cols="12" sm="6">
        <c-profile-panel :user="user" :env="env"/>
      </v-col>
      <v-col v-if="env.payment" cols="12" sm="6">
        <c-payment-panel :user="user"/>
      </v-col>
      <v-col v-if="env.optins" cols="12" sm="6">
        <c-optins-panel :user="user"/>
      </v-col>
    </v-row>

    <div class="d-flex flex-row flex-grow-1 mt-4">
      <v-spacer />
      <v-btn text outlined to="#back">OK</v-btn>
    </div>
  </c-container>
</template>

<script>
import page from '@/mixins/page'
import CAccountPanel from './CAccountPanel'
import CProfilePanel from './CProfilePanel'
import CPaymentPanel from './CPaymentPanel'
import COptinsPanel from './COptinsPanel'

import * as api from '@/api'
import * as C from '@/consts'

export default {
  name: 'Account',
  mixins: [
    page('アカウント情報')
  ],
  components: {
    CAccountPanel,
    CProfilePanel,
    CPaymentPanel,
    COptinsPanel
  },

  /**
   * データ取得
   */
  async prepare (to, from, store) {
    // ログイン中のユーザID を取得する
    const userID = store.getters['user/id']

    // org traits から表示すべき項目を取得する
    const env = {
      license: false,
      payment: false,
      optins: false
    }

    const methods = store.getters['org/paymentMethods']
    env.payment = (methods.findIndex(method => method !== C.PAY_SPOT) >= 0)
    env.license = store.getters['org/needLicense']
    env.optins = store.getters['org/optins']

    // API からユーザ情報のサマリを取得する
    const resp = await api.getUserSummary(userID)
    const user = resp.data

    return {
      env,
      user
    }
  },

  props: {
    env: Object,
    user: Object
  }
}
</script>
